import { render, staticRenderFns } from "./GameDialog.vue?vue&type=template&id=04407180&scoped=true"
import script from "./GameDialog.vue?vue&type=script&lang=js"
export * from "./GameDialog.vue?vue&type=script&lang=js"
import style0 from "./GameDialog.vue?vue&type=style&index=0&id=04407180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04407180",
  null
  
)

export default component.exports